function remove_duplicate_elements(a){
    var l = new Set(a);
    return Array.from(l);
}   
function get_current_timestamp(){
    /*
    var date = new Date();
	var current_date = date.getFullYear()+"-"+(date.getMonth()+1)+"-"+ date.getDate();
	var current_time = date.getHours()+":"+date.getMinutes()+":"+ date.getSeconds();
	var date_time = current_date+" "+current_time;	*/
    let date = Date.now();

    return date;
}
export {remove_duplicate_elements, get_current_timestamp};